import { IconButton, Tooltip } from '@nimbus-ds/components';
import { EditIcon, StarIcon, TrashIcon } from '@nimbus-ds/icons';
import { DataList } from '@nimbus-ds/patterns';
import { LocationResponseDto } from '@tiendanube/common';
import { useNavegate } from 'App/hooks';
import { PopoverMenu, Stack } from 'commons/components';
import LocationItem from 'domains/Shipping/Locations/pages/LocationListPage/components/LocationItem';
import { trackingShippingEditDistributionCenter } from 'domains/Shipping/tracking';
import useTranslationShipping from 'domains/Shipping/useTranslationShipping';
import LocationsListRowMobileSkeleton from './Skeleton';
import useDeleteLocationJob from '../../../../useDeleteLocationJob';

interface LocationsListRowProps {
  location: LocationResponseDto;
  openSetMainModal: (locationId: any) => void;
  openDeleteModal: (locationId: any) => void;
}

function LocationsListRow({
  location,
  openSetMainModal,
  openDeleteModal,
}: Readonly<LocationsListRowProps>): JSX.Element | null {
  const { goTo } = useNavegate();
  const t = useTranslationShipping();
  const { deletingLocationId } = useDeleteLocationJob();
  const { Row } = DataList;
  const handleClick = () => {
    trackingShippingEditDistributionCenter('secondary', location.id);
    goTo(`/settings/locations/${location.id}`);
  };

  const menu = [
    {
      label: t('locations.card.edit'),
      onClick: handleClick,
      startIcon: EditIcon,
      disabled: deletingLocationId === location.id,
    },
    {
      label: t('locations.card.setAsMain'),
      onClick: () => openSetMainModal(location.id),
      startIcon: StarIcon,
      disabled: deletingLocationId === location.id,
    },
    {
      label: t('locations.card.delete'),
      onClick: () => openDeleteModal(location.id),
      startIcon: TrashIcon,
      disabled: !!deletingLocationId,
    },
  ];
  return (
    <Row id={location.id} key={location.id} topDivider paddingLeft="none">
      <Stack spacing="loose" justify="space-between">
        <Stack.Item />
        <LocationItem location={location} />
        <Stack.Item>
          {location.main && (
            <Tooltip content={t('locations.card.edit')}>
              <IconButton
                size="2rem"
                source={<EditIcon size="small" />}
                onClick={handleClick}
                disabled={deletingLocationId === location.id}
              />
            </Tooltip>
          )}
          {!location.main && <PopoverMenu actions={menu} />}
        </Stack.Item>
      </Stack>
    </Row>
  );
}

LocationsListRow.Skeleton = LocationsListRowMobileSkeleton;

export default LocationsListRow;
